import { useEffect, useState } from "react";
import { Form, Layout } from "antd";
import { useParams } from "react-router-dom";
import PageHeader from "../../../components/page-header/PageHeader";
import "./style.scss";
import { useLocation } from "react-router-dom";
import SettingThemeBlogContent from "../../../components/blog-and-forum/design-theme-blog-content";


type Props = {
  title?: string;
};

const DesignThemeBlogContentPage = (props: Props) => {
const { title } = props

  const getDetailCourseData = async () => { };

  useEffect(() => {
    getDetailCourseData();
  }, []);

  return (
    <>
      <Layout className="page-header-group portal-adminstration">
        <Form.Provider
          onFormFinish={(name, { values, forms }) => {

          }}
        >
          <div
            className={`page-header item-vertical z-10}`}
          >
            <div className="table-header--wrapper">
              <div className="table-header--left">
                <PageHeader title={title} />
              </div>
            </div>
            <div className={`wrapper-filter`}>
            </div>
          </div>

          <div className="tabs-heading z-[49]">
            <SettingThemeBlogContent />
          </div>
        </Form.Provider>
      </Layout>
    </>
  );
};

export default DesignThemeBlogContentPage;
